/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AssignColors from './AssignColors/index'
import ChangeStatus from './ChangeStatus/index'
import CompleteTreatment from './CompleteTreatment/index'
import Delete from './Delete/index'
import EditLength from './EditLength/index'
import EditLocation from './EditLocation/index'
import MoveToAnotherTreatment from './MoveToAnotherTreatment/index'
import PrintPDF from './PrintPDF/index'
import Questionnaires from './Questionnaires/index'
import React from 'react'
import Rename from './Rename/index'
import ReorderEntries from './ReorderEntries/index'
import StartContract from './StartContract/index'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 onClick={onClick}
 data="options"
 from={optionsValueData}
 paddingTop={0}
 paddingLeft={0}
 paddingBottom={0}
 paddingRight={0}
 marginRight={6}
 height={450}
 width={250}
 valueWidth="auto"
 selectedBackgroundColor="transparent"
/>
</div>
<Rename
  viewPath={`${viewPath}/Rename`}
/>
<ReorderEntries
  viewPath={`${viewPath}/ReorderEntries`}
/>
<StartContract
  viewPath={`${viewPath}/StartContract`}
/>
<PrintPDF
  viewPath={`${viewPath}/PrintPDF`}
/>
<EditLength
  viewPath={`${viewPath}/EditLength`}
/>
<EditLocation
  viewPath={`${viewPath}/EditLocation`}
/>
<MoveToAnotherTreatment
  viewPath={`${viewPath}/MoveToAnotherTreatment`}
/>
<AssignColors
  viewPath={`${viewPath}/AssignColors`}
/>
<CompleteTreatment
  viewPath={`${viewPath}/CompleteTreatment`}
/>
<ChangeStatus
  viewPath={`${viewPath}/ChangeStatus`}
/>
<Questionnaires
  viewPath={`${viewPath}/Questionnaires`}
/>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
{children}
</React.Fragment>)
}